/**
 * Sentry rewriteFrames iteratee.
 *
 * Source maps are uploaded with urlPrefix `~/packs/js` (see
 * config/rspack/rspack.production.js), but at runtime ASSET_HOST may serve
 * bundles from a per-deploy versioned prefix, e.g.
 *   https://cdn.medsender.com/assets/<deploy-tag>/packs/js/*.js
 * The promote-to-production pipeline serves a staging-built image under a
 * `production-<tag>` prefix that differs from the SENTRY_RELEASE baked into
 * that image, so a release-derived urlPrefix can never match all pipelines.
 *
 * Stripping the `/assets/<deploy-tag>` segment back to `<origin>/packs/js/...`
 * realigns every frame with the uploaded artifact names regardless of which
 * deploy pipeline produced the running ASSET_HOST.
 */

const PACKS_JS_MARKER = '/packs/js/';

// eslint-disable-next-line import/prefer-default-export
export const normalizeSentryFrame = (frame) => {
  const original = frame.filename;
  if (typeof original !== 'string') {
    return frame;
  }

  const markerIndex = original.indexOf(PACKS_JS_MARKER);
  if (markerIndex === -1) {
    return frame;
  }

  try {
    const url = new URL(original);
    /* eslint-disable-next-line no-param-reassign */
    frame.filename = `${url.origin}${original.slice(markerIndex)}`;
  } catch {
    // Relative / non-URL filename: fall back to a host-agnostic path.
    /* eslint-disable-next-line no-param-reassign */
    frame.filename = original.slice(markerIndex);
  }

  return frame;
};
